const getters = {
  systemName: state => state.app.systemName,
  openAdvertisingSpace: state => state.app.openAdvertisingSpace,
  
  //侧边栏相关
  openSidebar: state => state.app.openSidebar,
  device: state => state.app.device,
  screenHeight: state => state.app.screenHeight,
  systemConfig: state => state.app.systemConfig,
  
  // iframeList
  iframeList: state => state.tagsView.iframeList,

  // token
  accessToken: state => state.user.accessToken,
  refreshToken: state => state.user.refreshToken,
  
  // 用户信息
  userInfo: state => state.user.userInfo, // 用户信息
  permissionList: state => state.user.permissionList, // 按钮和列表接口权限标识列表
  allMenuList: state => state.user.allMenuList, // 用户拥有的所有菜单列表包括按钮
  sqlTableList: state => state.user.sqlTableList, // 数据表权限标识 回收站使用
  sidebarMenuTree: state => state.user.sidebarMenuTree, // 侧边菜单树包含 hidden的部分数据
  roleIdList: state => state.user.roleIdList, // 含有的角色id列表
  isEncrypt: state => state.user.isEncrypt // 获取接口是否进行加密处理
}
export default getters
